// soapNoteActions.js

export const GET_SUBJECTIVES = "GET_SUBJECTIVES";
export const ADD_SUBJECTIVE = "ADD_SUBJECTIVE";
export const UPDATE_SUBJECTIVE = "UPDATE_SUBJECTIVE";

export const GET_OBJECTIVES = "GET_OBJECTIVES";
export const ADD_OBJECTIVE = "ADD_OBJECTIVE";
export const UPDATE_OBJECTIVE = "UPDATE_OBJECTIVE";

export const GET_ASSESSMENTS = "GET_ASSESSMENTS";
export const ADD_ASSESSMENT = "ADD_ASSESSMENT";
export const UPDATE_ASSESSMENT = "UPDATE_ASSESSMENT";

export const GET_PLANS = "GET_PLANS";
export const ADD_PLAN = "ADD_PLAN";
export const UPDATE_PLAN = "UPDATE_PLAN";

export const getSubjectives = (subjectives) => ({
  type: GET_SUBJECTIVES,
  subjectives,
});

export const addSubjective = (subjective) => ({
  type: ADD_SUBJECTIVE,
  subjective,
});

export const updateSubjective = (subjective) => ({
  type: UPDATE_SUBJECTIVE,
  subjective,
});

export const getObjectives = (objectives) => ({
  type: GET_OBJECTIVES,
  objectives,
});

export const addObjective = (objective) => ({
  type: ADD_OBJECTIVE,
  objective,
});

export const updateObjective = (objective) => ({
  type: UPDATE_OBJECTIVE,
  objective,
});

export const getAssessments = (assessments) => ({
  type: GET_ASSESSMENTS,
  assessments,
});

export const addAssessment = (assessment) => ({
  type: ADD_ASSESSMENT,
  assessment,
});

export const updateAssessment = (assessment) => ({
  type: UPDATE_ASSESSMENT,
  assessment,
});

export const getPlans = (plans) => ({
  type: GET_PLANS,
  plans,
});

export const addPlan = (plan) => ({
  type: ADD_PLAN,
  plan,
});

export const updatePlan = (plan) => ({
  type: UPDATE_PLAN,
  plan,
});
